<div class="w-full">
  <!-- Search Bar -->
  <div class="glass-card p-4 rounded-2xl mb-6">
    <div class="flex flex-col md:flex-row gap-4 items-start md:items-center">
      <div class="relative flex-1 max-w-md">
        <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <span class="material-icons text-xl text-text-muted">search</span>
        </div>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (input)="onSearchChange()"
          placeholder="Suche nach Auftrags-Nr., Kunde oder Lieferzettel..."
          class="search-input w-full pl-12 pr-10 py-3 rounded-xl bg-white/8 border border-white/12 text-text-primary placeholder-text-muted focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all"
        />
        @if (searchTerm) {
          <button
            type="button"
            class="absolute inset-y-0 right-0 pr-4 flex items-center text-text-muted hover:text-text-primary transition-colors"
            (click)="clearSearch()"
          >
            <span class="material-icons text-xl">close</span>
          </button>
        }
      </div>

      <div class="md:ml-auto">
        <button type="button" class="btn-primary flex items-center gap-2" (click)="openOrderModal()">
          <span class="material-icons text-xl">add</span>
          Auftrag hinzufügen
        </button>
      </div>
    </div>
  </div>

  <!-- Orders Table -->
  <div class="glass-card rounded-2xl overflow-hidden">
    <!-- Loading State -->
    @if (isLoading) {
      <div class="flex items-center justify-center py-20">
        <div class="animate-spin rounded-full h-8 w-8 border-2 border-primary border-t-transparent"></div>
      </div>
    } @else {
      <div class="overflow-x-auto">
        <table class="w-full">
          <thead>
            <tr class="border-b border-white/10">
              <th class="table-header" (click)="onSort('internalOrderId')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Auftrags-Nr.
                  <span class="material-icons text-lg">{{ getSortIcon('internalOrderId') }}</span>
                </div>
              </th>
              <th class="table-header" (click)="onSort('companyName')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Kunde
                  <span class="material-icons text-lg">{{ getSortIcon('companyName') }}</span>
                </div>
              </th>
              <th class="table-header" (click)="onSort('mandantId')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Mandat-ID
                  <span class="material-icons text-lg">{{ getSortIcon('mandantId') }}</span>
                </div>
              </th>
              <th class="table-header" (click)="onSort('customerNr')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Kunden-Nr.
                  <span class="material-icons text-lg">{{ getSortIcon('customerNr') }}</span>
                </div>
              </th>
              <th class="table-header">
                <div class="flex items-center gap-1">Lieferzettel</div>
              </th>
              <th class="table-header" (click)="onSort('createdAt')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Erstellt am
                  <span class="material-icons text-lg">{{ getSortIcon('createdAt') }}</span>
                </div>
              </th>
              <th class="table-header" (click)="onSort('updatedAt')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Aktualisiert am
                  <span class="material-icons text-lg">{{ getSortIcon('updatedAt') }}</span>
                </div>
              </th>
              <th class="table-header">
                <span class="sr-only">Aktionen</span>
              </th>
            </tr>
          </thead>
          <tbody>
            @if (orders.length === 0) {
              <tr>
                <td colspan="8" class="px-6 py-12 text-center text-text-muted">Keine Aufträge gefunden...</td>
              </tr>
            } @else {
              @for (order of orders; track order._id) {
                <!-- Main Order Row -->
                <tr
                  class="table-row border-b border-white/6 transition-colors"
                  [class.cursor-pointer]="getDeliveryNotesCount(order) > 0"
                  [class.hover:bg-white/4]="getDeliveryNotesCount(order) > 0"
                  [class.bg-white/4]="isRowExpanded(order)"
                  (click)="toggleRow(order)"
                >
                  <td class="table-cell">
                    <div class="flex items-center gap-2">
                      @if (getDeliveryNotesCount(order) > 0) {
                        <span
                          class="material-icons text-lg text-text-muted transition-transform duration-200"
                          [class.rotate-90]="isRowExpanded(order)"
                        >
                          chevron_right
                        </span>
                      } @else {
                        <span class="w-6"></span>
                      }
                      <span class="font-medium text-text-primary">{{ order.internalOrderId }}</span>
                    </div>
                  </td>
                  <td class="table-cell">{{ order.companyName }}</td>
                  <td class="table-cell">{{ order.mandantId }}</td>
                  <td class="table-cell">{{ order.customerNr }}</td>
                  <td class="table-cell">
                    <span class="inline-block px-2.5 py-1 rounded-full text-xs font-semibold bg-blue-400/15 text-blue-400">
                      {{ getDeliveryNotesCount(order) }} Lieferzettel
                    </span>
                  </td>
                  <td class="table-cell">
                    <span class="text-xs bg-white/8 px-2 py-1 rounded">{{ formatDate(order?.createdAt) }}</span>
                  </td>
                  <td class="table-cell">
                    <span class="text-xs bg-white/8 px-2 py-1 rounded">{{ formatDate(order?.updatedAt) }}</span>
                  </td>
                  <td class="table-cell">
                    <button
                      type="button"
                      class="p-2 rounded-lg text-text-muted hover:text-primary hover:bg-white/10 transition-all flex items-center justify-center"
                      (click)="openOrderModal(order); $event.stopPropagation()"
                      title="Bearbeiten"
                    >
                      <span class="material-icons text-lg">edit</span>
                    </button>
                  </td>
                </tr>

                <!-- Expanded Delivery Notes Sub-Table -->
                @if (isRowExpanded(order) && order._id) {
                  <tr class="expanded-row">
                    <td colspan="8" class="p-0">
                      <div class="bg-surface-dark/50 border-y border-white/6">
                        <!-- Loading State -->
                        @if (isLoadingDeliveryNotes(order._id)) {
                          <div class="flex items-center justify-center py-8">
                            <div class="animate-spin rounded-full h-6 w-6 border-2 border-primary border-t-transparent"></div>
                          </div>
                        } @else {
                          @if (getDeliveryNotesForOrder(order._id).length === 0) {
                            <div class="px-6 py-8 text-center text-text-muted">
                              <span class="material-icons text-3xl mb-2 block opacity-50">inbox</span>
                              Keine Lieferzettel für diesen Auftrag
                            </div>
                          } @else {
                            <!-- Sub-Table Header -->
                            <div class="px-6 py-3 border-b border-white/6">
                              <span class="text-xs font-semibold text-text-muted uppercase tracking-wider">Zugeordnete Lieferzettel</span>
                            </div>
                            <table class="w-full">
                              <thead>
                                <tr class="border-b border-white/6">
                                  <th class="sub-table-header">Lieferzettel-Nr.</th>
                                  <th class="sub-table-header">Positionen</th>
                                  <th class="sub-table-header">Status</th>
                                  <th class="sub-table-header">Mitarbeiter</th>
                                  <th class="sub-table-header">Erstellt am</th>
                                  <th class="sub-table-header w-12"></th>
                                </tr>
                              </thead>
                              <tbody>
                                @for (note of getDeliveryNotesForOrder(order._id); track note._id) {
                                  <tr
                                    class="sub-table-row border-b border-white/4 last:border-b-0 cursor-pointer hover:bg-white/4 transition-colors"
                                    (click)="openDeliveryNoteModal(note, order); $event.stopPropagation()"
                                  >
                                    <td class="sub-table-cell font-medium text-text-primary">{{ note.noteNumber }}</td>
                                    <td class="sub-table-cell">
                                      <span class="inline-block px-2 py-0.5 rounded-full text-xs font-semibold bg-white/8 text-text-secondary">
                                        {{ getPositionsCount(note) }} Pos.
                                      </span>
                                    </td>
                                    <td class="sub-table-cell">
                                      <span
                                        class="inline-block px-2 py-0.5 rounded-full text-xs font-semibold"
                                        [ngClass]="getStatusClass(note.status)"
                                      >
                                        {{ getStatusName(note.status) }}
                                      </span>
                                    </td>
                                    <td class="sub-table-cell text-text-muted">{{ note.employeeId }}</td>
                                    <td class="sub-table-cell">
                                      <span class="text-xs text-text-muted">{{ formatDate(note.createdAt) }}</span>
                                    </td>
                                    <td class="sub-table-cell">
                                      <button
                                        type="button"
                                        class="p-1.5 rounded-lg text-text-muted flex items-center justify-center hover:text-primary hover:bg-white/10 transition-all"
                                        (click)="openDeliveryNoteModal(note, order); $event.stopPropagation()"
                                        title="Ansehen"
                                      >
                                        <span class="material-icons text-base">visibility</span>
                                      </button>
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          }
                        }
                      </div>
                    </td>
                  </tr>
                }
              }
            }
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      @if (totalItems > 0) {
        <div class="px-6 py-4 border-t border-white/10">
          <app-pagination
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [totalItems]="totalItems"
            [pageSize]="pageSize"
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      }
    }
  </div>
</div>

<!-- Delivery Note Overview Modal -->
@if (showOverviewModal) {
  <app-delivery-note-overview-modal
    [deliveryNote]="selectedDeliveryNote"
    [orderInfo]="selectedOrderInfo"
    (close)="closeOverviewModal()"
    (edit)="onEditFromModal($event)"
  ></app-delivery-note-overview-modal>
}
